'use client';

import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common/Anchor/LinkStyled';
import { useCoachingGreeting } from '@hooks/features/useCoachingGreeting';

/**
 * Empty-state landing for the candidate coaching (bestie-chat) view. Interview stories now live
 * on the separate Interviews page (/stories); coaching shows a single personalised greeting —
 * title + description — until the user starts a chat from the CandidatePromptBar below.
 */
export const CoachingLanding = () => {
  const { t } = useTranslation('common');
  const { title, description } = useCoachingGreeting();

  return (
    <div className="flex grow flex-col items-center justify-end px-4 pb-16 pt-8 md:pb-12">
      <div className="flex w-full max-w-5xl flex-col items-center gap-4 text-center">
        <span className="min-h-[1.375em] w-full text-balance text-3xl font-bold leading-snug sm:text-4xl lg:text-[56px] lg:leading-tight">
          {title}
        </span>

        {description && (
          <p className="max-w-5xl text-base text-ink-medium md:text-lg">
            {description}
          </p>
        )}

        <LinkStyled href="/my-bestie" styling="none" className="mt-6 text-center underline underline-offset-4">
          {t('my.bestie.home.cta.short')}
        </LinkStyled>
      </div>
    </div>
  );
};
